import { FormControl } from '@angular/forms';

/**
 * Class representing the Validation helper.
 */
export class ValidationHelper {

	/**
	 * Validates an email address (with domain extension).
	 * @param {FormControl} c - Angular form FormControl object
	 * @return {object} Angular form FormControl validation object
	 */
	static validateEmail(c: FormControl): { [key: string]: any } {
		const emailRegexp = /^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i;
		return emailRegexp.test(c.value) ? null : {
			validateEmail: {
				valid: false
			}
		};
	}

	/**
	 * Validates an email address (with domain extension).
	 * @param {FormControl} c - Angular form FormControl object
	 * @return {object} Angular form FormControl validation object
	 */
	static validateHuEmail(c: FormControl): { [key: string]: any } {
		const emailRegexp = /^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@waddinxveen\.nl$/i; // [THEME] Change validator dropbox email
		return emailRegexp.test(c.value) ? null : {
			validateHuEmail: {
				valid: false
			}
		};
	}
}
